export default {
    userBaseData: 'Daten',
    newsletter: 'Mitteilungen',
    userSignature: 'Signatur',
    userFilters: 'Gespeicherte Filterkombinationen',
    userOrganisations: 'Organisationen',
    userActivities: 'Historie',
    userCommunications: 'Kommunikation'
}